<template>
	<div>
		<div class="d-flex align-items-center">
			<div class="mcqtophead">Communication</div>
			<div class="mcqtophead">
				Difficulty Level - {{ data.difficultyLevel }}
			</div>
			<div class="mcqtophead">{{ data.marks }} Mark</div>
		</div>

		<div class="questiontext">
			<div class="d-flex">
				<span class="mr-2">Q{{ showindex }}.</span
				><span class="topicDescBreak" v-html-safe="data.question"></span>
			</div>
			<div class="my-3" v-if="data.questionMedia != null">
				<div v-if="isImage(data.questionMediaType)">
					<img
						class="qb-image-preview w-100"
						:src="data.questionMedia"
						alt=""
					/>
				</div>
				<div v-if="isAudio(data.questionMediaType)" class="d-flex">
					<Media
						:kind="'audio'"
						:isMuted="false"
						:src="data.questionMedia"
						:autoplay="false"
						:controls="true"
						:loop="true"
						class="qb-audio-preview"
					></Media>
				</div>
				<div v-if="isVideo(data.questionMediaType)" class="d-flex">
					<Media
						:kind="'video'"
						:isMuted="false"
						:src="data.questionMedia"
						:autoplay="false"
						:controls="true"
						:loop="true"
						width="70%"
						height="30%"
						class="qb-vedio-preview"
					></Media>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
export default {
	name: "CommunicationCard",
	props: {
		data: Object,
		showindex: Number,
	},
	data() {
		return {
			selected: "first",
		};
	},
	methods: {
		isImage,
		isVideo,
		isAudio,
	},
};
</script>
